import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

/* istanbul ignore file */

@Injectable()
export class OHEntityViewerHttpInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Conditionally add headers for the specific download request
    const isDownloadFileRequest =
      request.method === 'POST' &&
      request.url.endsWith('/filehandler/files/download');

    if (isDownloadFileRequest) {
      const headers = request.headers
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/zip');

      // Clone request with updated headers
      request = request.clone({ headers });
    }

    return next.handle(request);
  }
}
